export default __webpack_public_path__ + "static/media/Het Patel.b377a03e.png";